<template>
  <v-tooltip bottom color="#2C2C2C">
    <template v-slot:activator="{ on, attrs }">
      <button
        v-if="toName"
        @click="$router.push({ name: toName, params: { id: id } })"
        class="editBtn"
        :class="{ fixed: fixed }"
        v-bind="attrs"
        v-on="on"
      >
        <IconsButton icon="button-edit" />
      </button>
      <button
        v-if="!toName && openModal"
        v-bind="attrs"
        v-on="on"
        type="button"
        @click.stop="openModal"
        class="editBtn"
        :class="{ fixed: fixed }"
      >
        <IconsButton icon="button-edit" />
      </button>
      <button
        v-if="!toName && click"
        v-bind="attrs"
        v-on="on"
        type="button"
        @click.stop="click"
        class="editBtn"
        :class="{ fixed: fixed }"
      >
        <IconsButton icon="button-edit" />
      </button>
      <BaseButton
        v-if="big"
        @click="bigClick"
        :text="localStorage.translations.pages.common['buttons']['redaktirovat']"
        :disabled="disabled"
        :reverse="reverse"
        default_icon="button-edit"
      />
    </template>
    <span>{{ localStorage.translations.pages.common['buttons']['redaktirovat'] }}</span>
  </v-tooltip>
</template>

<script>
import IconsButton from 'components/icons/button/IconsButton'

export default {
  name: 'EditBtn',
  components: { IconsButton },
  props: ['id', 'toName', 'openModal', 'fixed', 'big', 'click', 'bigClick', 'disabled', 'reverse'],
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.editBtn {
  display: grid;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 100%;
  svg:deep() {
    path {
      fill: #333333;
    }
  }
  &:hover {
    .arrow-5 {
      display: block;
    }
    svg:deep() {
      path {
        fill: #277faf;
      }
    }
  }
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    padding: 0 !important;
    background: #6fcf97;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    svg:deep() {
      path {
        fill: #ffffff;
      }
    }
    &:hover {
      opacity: 0.9;
      svg:deep() {
        path {
          fill: #ffffff;
        }
      }
    }
  }

  &.fixed:deep() {
    position: fixed;
    width: 60px;
    height: 60px;
    background-color: #277faf;
    box-shadow: 0px 4px 8px rgba(19, 85, 126, 0.3);
    border-radius: 50%;
    bottom: 170px;
    right: 10px;
    transition: 0.3s;
    svg {
      path {
        fill: #ffffff;
      }
    }
    &:hover {
      background-color: #16558f;
    }
  }
}
</style>
